import { IoMdLocate } from "react-icons/io";

const Geolocate = ({ globalRefs }) => {
    const polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;

    const locateUser = () => {
        if (!navigator.geolocation) {
            alert('Geolocation is not supported by this browser.');
            return;
        }
        navigator.geolocation.getCurrentPosition((position) => {
            const { latitude, longitude } = position.coords;
            polygonCustomLayerRef.current?.cameraFlyToLatLong(latitude, longitude);
        });
    };

    return (
        <button type="button" onClick={locateUser} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7, width: '100%', minHeight: 34, border: '1px solid #cbd7d3', borderRadius: 6, background: '#fff', color: '#245c50', fontSize: 12, cursor: 'pointer' }}>
            <IoMdLocate size={17} aria-hidden="true" />
            Geolocate
        </button>
    );
};

export default Geolocate;
